var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudDownloaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.83 6.425a5.312 5.312 0 00-3.296.472 5.078 5.078 0 00-2.306 2.308l-.345.708-.77-.17a3.501 3.501 0 00-.74-.084 3.517 3.517 0 00-2.394 1.014A3.283 3.283 0 002.002 13c0 .865.348 1.7.977 2.327a3.517 3.517 0 002.395 1.013h5.7a7.048 7.048 0 00-.001 2H5.34a5.518 5.518 0 01-3.773-1.596A5.283 5.283 0 01.002 13c0-1.405.565-2.749 1.566-3.745A5.518 5.518 0 015.34 7.66h.023c.144 0 .287.006.43.018a7.103 7.103 0 012.848-2.57 7.312 7.312 0 014.538-.651 7.21 7.21 0 014.016 2.177 6.942 6.942 0 011.734 3.383c.516.155.998.402 1.422.731a6.986 6.986 0 00-3.381-.329 4.942 4.942 0 00-1.24-2.422 5.21 5.21 0 00-2.902-1.571zm9.16 7.128l.796-.606 1.212 1.591-.796.606-5.638 4.295a1.07 1.07 0 01-1.346-.04l-2.723-2.342-.759-.652 1.304-1.517.759.652 2.152 1.851 5.04-3.838z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloaded);
export default __webpack_public_path__ + "static/media/cloud-downloaded.594196ce.svg";
export { ForwardRef as ReactComponent };